export default __webpack_public_path__ + "static/media/inspiratorio.af196cf7.png";